const lightbox = require('lightbox2');


lightbox.option({
    albumLabel: 'Zdjęcie %1 z %2',
    fadeDuration: 400,
    imageFadeDuration: 400,
    resizeDuration: 500
});
